import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { useMemo } from 'react'
import { getInitialValues, validationSchema } from './helpers'
import { useFormik } from 'formik'
import { makeCorePostRequest, makeCorePutRequest } from 'utils/api'
import { useNotification } from 'hooks'
import { useMutation } from 'react-query'
import { formatErrorMessage } from 'utils/formatting'
import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { getLocationUnit } from 'components/location/api'

const LocationChildFormModal = props => {
  const {
    isModalOpen,
    closeModal,
    isEdit,
    editItemId,
    parentId,
    setShouldRefreshData,
    shouldRefreshData
  } = props

  const { showNotification } = useNotification()

  const { data: editItem } = getLocationUnit(showNotification, editItemId, shouldRefreshData)

  const createChild = async values => {
    return isEdit
      ? await makeCorePutRequest(`/location-management/location-unit/${editItemId}`, values)
      : await makeCorePostRequest('/location-management/location-unit', values)
  }

  const { isLoading: isChildLoading, mutate: addChild } = useMutation(createChild, {
    onSuccess: (res, data) => {
      setShouldRefreshData(true)
      formik.resetForm()
      closeModal()
      showNotification({
        message: 'The changes were saved successfully.',
        type: 'success'
      })
    },
    onError: error => {
      showNotification({
        message: `There was an error while saving changes. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  })

  const initialValues = useMemo(() => getInitialValues(editItem), [editItem])

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async values => {
      const payload = isEdit
        ? {
            locationUnitName: values.locationUnitName
          }
        : {
            locationUnitName: values.locationUnitName,
            locationParentId: parentId
          }
      addChild(payload)
    }
  })

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      modalTitle={isEdit ? 'Edit child' : 'Add child'}
    >
      <Grid container spacing={2}>
        <Grid xs={12} item>
          <Input
            type="text"
            value={formik.values.locationUnitName}
            onChange={event =>
              formik.setFieldValue('locationUnitName', (event.target as HTMLInputElement).value)
            }
            label="Name"
            variant="outlined"
            style={{ width: '100%' }}
            error={!!formik.errors.locationUnitName}
            helperText={formik.errors.locationUnitName as string}
            required
          />
        </Grid>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={() => closeModal()} />
          <Button
            variant="contained"
            label={'Salveaza'}
            onClick={() => formik.handleSubmit()}
            disabled={isChildLoading}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default LocationChildFormModal
